import PhoneInput, { getCountryCallingCode } from "react-phone-number-input";
import type { Country } from "react-phone-number-input";
import { ComponentProps, ComponentType } from "react";
import SelectInput from "./SelectInput";

// Keep the library's country restrictions, International mode and number logic.
// This adapter changes only how its country options are presented. The trigger
// sits inside the phone field's own border, so it is a borderless flag + caret
// with a divider rather than a second bordered box.
const PhoneCountrySelect = ({ value, onChange, options, disabled, readOnly, onFocus, onBlur, iconComponent: Icon }: {
  value?: Country;
  onChange: (country?: Country) => void;
  options: { value?: Country; label: string; divider?: boolean }[];
  disabled?: boolean;
  readOnly?: boolean;
  onFocus?: () => void;
  onBlur?: () => void;
  iconComponent?: ComponentType<{ country?: Country; label: string; "aria-hidden"?: boolean }>;
}) => {
  const label = options.find(option => option.value === value)?.label ?? "International";
  return (
    <div className="PhoneCountryTrigger mr-3 shrink-0 self-stretch flex">
      <SelectInput selected={value ?? ""} onSelect={code => onChange(code ? code as Country : undefined)}
        disabled={disabled || readOnly} searchable placeholder="Phone country"
        onFocus={onFocus} onBlur={onBlur}
        triggerClassName="flex h-full items-center gap-1.5 pr-3 border-r border-gray-200 text-gray-500 rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-deepBlue/20 disabled:opacity-50 disabled:cursor-not-allowed"
        triggerContent={Icon ? <Icon aria-hidden country={value} label={label} /> : value ?? "Intl"}
        data={options.filter(option => !option.divider).map(option => ({
          id: option.value ?? "",
          value: option.value ? `${option.label} (${option.value}) +${getCountryCallingCode(option.value)}` : option.label,
        }))} />
    </div>
  );
};

const SearchablePhoneInput = (props: ComponentProps<typeof PhoneInput>) => (
  <PhoneInput {...props} countrySelectComponent={PhoneCountrySelect} />
);

export default SearchablePhoneInput;
